import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Tooltip } from 'antd';
import classnames from 'classnames/bind';
import { FC, memo, ReactNode } from 'react';
import styles from './TooltipCell.module.scss';

const cx = classnames.bind(styles);

export type TooltipCellProps = {
  title: string | null | undefined;
  children: ReactNode;
  wrapperClassName?: string;
};

export const TooltipCell: FC<TooltipCellProps> = memo(
  ({ title, children, wrapperClassName }) => {
    const container = useGlobalContainerRef();

    return (
      <Tooltip
        title={title ?? ''}
        getPopupContainer={container}
        overlayClassName={cx(styles['wrapper'])}
      >
        <div className={cx(styles['wrapper'], wrapperClassName)}>
          {children}
        </div>
      </Tooltip>
    );
  }
);

TooltipCell.displayName = 'TooltipCell';
